<app-menu-common url="sales"></app-menu-common>

<div class="tour-return-page">

  <!-- Sélecteur : même barre que la liste des commandes (identité, filtres, actions) -->
  <div class="toolbar-card">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">assignment_return</mat-icon>
      <span>Retour de tournée</span>
    </div>

    <div class="filter-item date-filter">
      <app-select-date label="Jour" [date]="date" (dateChange)="dateChange($event)"></app-select-date>
    </div>

    <!-- Les bascules de la fenêtre de livraison (c_values 10), ici à choix multiple : le serveur rend tous les types, l'écran choisit -->
    <!-- (change) et pas (valueChange) : ce dernier part aussi quand [value] est reposé, vide d'abord la liste des types, et pruneSelection vidait alors la sélection à chaque cycle -->
    <div class="filter-item">
      <span class="filter-label">Types</span>
      <mat-button-toggle-group class="modes" multiple [hideMultipleSelectionIndicator]="true" [value]="modes"
        (change)="setModes($event.value)" aria-label="Types de livraison affichés">
        @for (m of modeValues; track m.id) {
          <mat-button-toggle [value]="m.id">{{ m.name }} <span class="n">{{ countMode(m.id!) }}</span></mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <div class="filter-item">
      <span class="filter-label">Afficher</span>
      <div class="segmented">
        <button type="button" [class.on]="show === 'todo'" (click)="setShow('todo')">À traiter <span class="n">{{ countTodo }}</span></button>
        <button type="button" [class.on]="show === 'done'" (click)="setShow('done')">Livrés <span class="n">{{ countDone }}</span></button>
        <button type="button" [class.on]="show === 'all'" (click)="setShow('all')">Tous <span class="n">{{ modeRows.length }}</span></button>
      </div>
    </div>

    <div class="filter-item">
      <span class="filter-label">Sélectionner</span>
      <div class="segmented">
        <button type="button" [class.on]="isSlotFullySelected(null)" [disabled]="!countSlot(null)" (click)="selectSlot(null)"
          matTooltip="Tous les BL à traiter de la journée, types affichés">Journée <span class="n">{{ countSlot(null) }}</span></button>
        <button type="button" [class.on]="isSlotFullySelected(1)" [disabled]="!countSlot(1)" (click)="selectSlot(1)"
          matTooltip="Ajoute les BL du matin à la sélection">Matin <span class="n">{{ countSlot(1) }}</span></button>
        <button type="button" [class.on]="isSlotFullySelected(2)" [disabled]="!countSlot(2)" (click)="selectSlot(2)"
          matTooltip="Ajoute les BL de l'après-midi à la sélection">Après-midi <span class="n">{{ countSlot(2) }}</span></button>
        <button type="button" [disabled]="!selected.size" (click)="clearSelection()" matTooltip="Vider la sélection">
          <mat-icon>deselect</mat-icon></button>
      </div>
    </div>

    <div class="toolbar-actions">
      <button mat-flat-button class="btn-deliver" [disabled]="!selected.size" (click)="markDelivered()"
        [matTooltip]="isFuture ? 'Jour futur : les BL sélectionnés seront déclarés livrés maintenant' : 'Déclarer livrés les BL sélectionnés'">
        <mat-icon>task_alt</mat-icon>
        Passer à livré@if (selected.size) { &nbsp;({{ selected.size }})}
      </button>
      <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Actualiser" title="Recharger la journée" (click)="reload()">
        <mat-icon [class.spinning]="loading">refresh</mat-icon>
      </button>
    </div>

  </div>

  <div class="content-row">

    <div class="table-card">

      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>local_shipping</mat-icon>
          <span>Bons de livraison</span>
          <span class="badge-count">{{ visibleRows.length }}</span>
          <!-- Locations = BL des dossiers F3 et BL de vente de leurs passages, que le 703 livre avec eux ; ici et non dans la barre, qui tient sur une ligne à 1920 px -->
          <mat-button-toggle-group class="modes kinds" multiple [hideMultipleSelectionIndicator]="true" [value]="kinds"
            (change)="setKinds($event.value)" aria-label="Pièces affichées">
            <mat-button-toggle value="sale">Commandes <span class="n">{{ countKind('sale') }}</span></mat-button-toggle>
            <mat-button-toggle value="rental">Locations <span class="n">{{ countKind('rental') }}</span></mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="kpi-inline">
          <div class="kpi-chip" matTooltip="BL sélectionnés pour le passage à livré">
            <mat-icon class="kpi-icon">check_box</mat-icon>
            <span class="kpi-label">Sélection</span>
            <span class="kpi-value">{{ selected.size }}</span>
          </div>
          <div class="kpi-chip due" [class.zero]="countMissingScan === 0" matTooltip="BL à traiter sans scan du BL signé ni signature à l'écran">
            <mat-icon class="kpi-icon">document_scanner</mat-icon>
            <span class="kpi-label">Sans scan</span>
            <span class="kpi-value">{{ countMissingScan }}</span>
          </div>
        </div>
      </div>

      <div class="table-bl">

        <div class="bl-line entete">
          <div class="cell sel-cell">
            <mat-checkbox [checked]="allVisibleSelected" [disabled]="!countTodo" (change)="toggleAllVisible($event.checked)"
              matTooltip="Cocher / décocher les BL affichés"></mat-checkbox>
          </div>
          <div class="cell">BL</div>
          <div class="cell">Cde</div>
          <div class="cell">Type</div>
          <div class="cell" matTooltip="Dossier de location : → à livrer, ← à reprendre ; « avec » = vente livrée avec le BL du dossier">Location</div>
          <div class="cell">Créneau</div>
          <div class="cell">Tournée</div>
          <div class="cell">Client</div>
          <div class="cell">Ville</div>
          <div class="cell">État</div>
          <div class="cell num-cell" matTooltip="Reste à livrer de la commande, annulations déduites">R.A.L</div>
          <div class="cell">Scan du BL signé</div>
        </div>

        @for (r of visibleRows; track r.d.id; let isEven = $even) {
          <!-- role group et non button : la ligne contient case, lien et boutons, qu'un role button rendrait muets -->
          <div class="bl-line" [class.even]="isEven" [class.done]="isDone(r)" [class.checked]="selected.has(r.d.id)"
            [class.row-selected]="focused === r" [class.drag-over]="dragOverId === r.d.id"
            tabindex="0" role="group" [attr.aria-label]="'BL ' + r.d.id + ' — Entrée : lignes, aperçu et scan'"
            (click)="focus(r)" (keydown.enter)="focus(r)" (dragover)="onDragOver(r, $event)" (dragleave)="onDragLeave(r)" (drop)="onDrop(r, $event)">
            <div class="cell sel-cell" (click)="$event.stopPropagation()">
              <mat-checkbox [checked]="selected.has(r.d.id)" [disabled]="isDone(r)" (change)="toggle(r, $event.checked)"></mat-checkbox>
            </div>
            <div class="cell id-cell">{{ r.d.id }}</div>
            <div class="cell order-cell">
              <a [routerLink]="['/sales/quotation', r.d.id_order]" (click)="$event.stopPropagation()" matTooltip="Ouvrir la commande">{{ r.d.id_order }}</a>
            </div>
            <div class="cell"><span class="mode-pill" [attr.data-mode]="r.d.mode" [matTooltip]="modeLabel(r.d.mode)">{{ modeShort(r.d.mode) }}</span></div>
            <div class="cell rental-cell">
              @if (r.rental; as k) {
                <span class="rental-pill" [class.passage]="k.head" [matTooltip]="rentalTip(r)">
                  @if (k.head) { avec {{ k.head }} }
                  @else if (!k.posed && !k.taken) { Location }
                  @else {
                    @if (k.posed) { <app-rental-direction typ="RENTAL" [qty]="1"></app-rental-direction>{{ k.posed }} }
                    @if (k.taken) { <app-rental-direction typ="RENTAL" [qty]="-1"></app-rental-direction>{{ k.taken }} }
                  }
                </span>
              }
            </div>
            <div class="cell"><span class="slot-pill" [class.am]="r.day === 1" [class.pm]="r.day === 2">{{ dayLabel(r.day) }}</span></div>
            <div class="cell run-cell" [class.none]="!r.run">{{ runLabel(r) }}</div>
            <div class="cell customer-cell" [title]="addressLabel(r)">{{ customerLabel(r) }}</div>
            <div class="cell city-cell">{{ cityLabel(r) }}</div>
            <div class="cell state-cell">
              @if (isDone(r)) {
                <span class="state-pill done">{{ isReprise(r) ? 'Repris' : 'Livré' }} {{ r.d.realdatdel | date:'dd/MM HH:mm' }}</span>
              } @else {
                <span class="state-pill" [class.reprise]="isReprise(r)">{{ isReprise(r) ? 'À reprendre' : 'À livrer' }}</span>
              }
            </div>
            <div class="cell num-cell ral-cell" [class.due]="(r.d.ral ?? 0) > 0">{{ (r.d.ral ?? 0) > 0 ? r.d.ral : '' }}</div>
            <div class="cell docs-cell" (click)="$event.stopPropagation()">
              @for (a of r.docs; track a.id) {
                <button type="button" class="doc-chip" [class.scan]="isScan(a)" (click)="openDoc(a)" [matTooltip]="a.name ?? ''">
                  <mat-icon>{{ a.contenttype === 'application/pdf' ? 'picture_as_pdf' : 'image' }}</mat-icon>
                  <span>{{ isScan(a) ? 'Scan' : (a.name ?? 'Doc') }}</span>
                </button>
              }
              @if (r.uploading) {
                <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
              }
              <button type="button" class="doc-add" (click)="picker.click()" matTooltip="Joindre le scan du BL signé (PDF, JPEG, PNG, WebP, TIFF, HEIC) — ou déposer le fichier sur la ligne">
                <mat-icon>upload_file</mat-icon>
              </button>
              <input #picker type="file" hidden multiple accept="application/pdf,image/jpeg,image/png,image/webp,image/tiff,image/heic" (change)="onFilesPicked(r, picker)">
            </div>
          </div>
        } @empty {
          @if (loading) {
            <div class="loading-bl">
              <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
              <span>Chargement des bons de livraison…</span>
            </div>
          } @else {
            <div class="empty-bl">
              <mat-icon class="empty-icon">local_shipping</mat-icon>
              <div class="empty-title">Aucun bon de livraison</div>
              <div class="empty-subtitle">
                @if (rows.length) { Aucun BL dans cet affichage&nbsp;: changez « Types », « Commandes / Locations » ou « Afficher ». }
                @else { Aucune livraison n'est demandée pour ce jour. }
              </div>
            </div>
          }
        }
      </div>
    </div>

    <!-- BL cliqué : ses lignes face à la commande (reste à livrer, annulation), ses pièces jointes, la zone de dépôt du scan -->
    <div class="rightcontainer">
      @if (focused; as f) {
        <div class="preview-card">
          <div class="preview-head">
            <div class="preview-title">BL {{ f.d.id }} <span class="muted">· Cde {{ f.d.id_order }}</span></div>
            <a mat-stroked-button class="btn-open" [routerLink]="['/sales/quotation', f.d.id_order]">
              <mat-icon>open_in_new</mat-icon>Commande
            </a>
          </div>
          <div class="preview-field"><span class="k">Client</span><span>{{ customerLabel(f) }}</span></div>
          <div class="preview-field"><span class="k">Adresse</span><span>{{ addressLabel(f) || '—' }}</span></div>
          <div class="preview-field"><span class="k">Type</span><span>{{ modeLabel(f.d.mode) }}</span></div>
          @if (f.rental) {
            <div class="preview-field"><span class="k">Location</span><span>{{ rentalTip(f) }}</span></div>
          }
          <div class="preview-field"><span class="k">Tournée</span><span>{{ runLabel(f) }} · {{ dayLabel(f.day) }}</span></div>
          <div class="preview-field"><span class="k">État</span>
            <span>@if (isDone(f)) { {{ isReprise(f) ? 'Repris' : 'Livré' }} le {{ f.d.realdatdel | date:'dd/MM/yyyy HH:mm' }} } @else { {{ isReprise(f) ? 'À reprendre' : 'À livrer' }} }@if (f.d.datinvoicing) { · facturé }</span>
          </div>

          @if (detail; as dt) {
            <div class="lines">
              <div class="lines-head">
                <span class="lines-title">Lignes</span>
                @if (cancelCount) {
                  <span class="cancel-chip" matTooltip="Bons d'annulation déjà posés sur la commande">{{ cancelCount }} annulation{{ cancelCount > 1 ? 's' : '' }}</span>
                }
                @if (dt.loading && dt.lines.length) {
                  <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
                }
                <span class="grow"></span>
                @if (dt.order) {
                  <span class="ral-chip" [class.zero]="detailRal === 0" matTooltip="Reste à livrer de la commande : ni sur un BL, ni annulé">
                    @if (isSettled) { Commande soldée } @else { R.A.L {{ detailRal }} }
                  </span>
                }
              </div>

              @if (dt.loading && !dt.lines.length) {
                <div class="lines-wait">
                  <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="3"></mat-progress-spinner>
                  <span>Chargement des lignes de la commande…</span>
                </div>
              } @else if (dt.error) {
                <div class="lines-error"><mat-icon>error_outline</mat-icon><span>{{ dt.error }}</span></div>
              } @else if (dt.order) {
                @if (!canEditLines && lockReason) {
                  <div class="lines-lock"><mat-icon>lock</mat-icon><span>{{ lockReason }}</span></div>
                }
                <div class="lines-grid" [class.cancelling]="dt.cancelling">
                  <div class="lg-row lg-head">
                    <div class="lg-c">Produit</div>
                    <div class="lg-c num" matTooltip="Quantité commandée">Cdé</div>
                    <div class="lg-c num" matTooltip="Quantité portée par ce BL">Ce BL</div>
                    <div class="lg-c num" matTooltip="Autres BL de la commande, livrés ou à livrer">Autres</div>
                    <div class="lg-c num" matTooltip="Déjà soldé par un bon d'annulation">Annulé</div>
                    <div class="lg-c num" matTooltip="Reste à livrer : commandé − ce BL − autres BL − annulé">R.A.L</div>
                    @if (dt.cancelling) {
                      <div class="lg-c num" matTooltip="Quantité soldée par le bon d'annulation">Annuler</div>
                    }
                  </div>
                  @for (l of dt.lines; track l.id) {
                    <div class="lg-row" [class.changed]="l.qty !== l.saved">
                      <div class="lg-c prod">
                        <a [routerLink]="['/sales/product', l.product]" target="_blank" tabindex="-1">{{ l.name }}</a>
                        @if (l.packaging) { <em>— {{ l.packaging }}</em> }
                        @if (l.article) { <small class="article">{{ l.article }}</small> }
                      </div>
                      <div class="lg-c num">{{ l.ordered }}</div>
                      <div class="lg-c num">
                        @if (canEditLines && !dt.cancelling) {
                          <input class="qty" type="number" [attr.min]="minOnBl(l)" step="any" onfocus="this.select()" [(ngModel)]="l.qty"
                            [class.bad]="isQtyBad(l)" [attr.aria-label]="'Quantité sur ce BL : ' + l.name" [matTooltip]="'De ' + minOnBl(l) + ' à ' + maxOnBl(l) + (minOnBl(l) < 0 ? ' (reprise du matériel)' : '')">
                        } @else {
                          {{ l.saved || '' }}
                        }
                      </div>
                      <div class="lg-c num muted">{{ l.others || '' }}</div>
                      <div class="lg-c num" [class.cancelled]="l.cancelled > 0">{{ l.cancelled || '' }}</div>
                      <div class="lg-c num ral" [class.due]="lineRal(l) > 0">{{ lineRal(l) >= 0 ? lineRal(l) : '—' }}</div>
                      @if (dt.cancelling) {
                        <div class="lg-c num">
                          @if (lineRal(l) > 0) {
                            <input class="qty cancel" type="number" min="0" step="any" onfocus="this.select()" [(ngModel)]="l.cancel"
                              [class.bad]="l.cancel !== null && isCancelBad(l)" [attr.aria-label]="'Quantité à annuler : ' + l.name" [matTooltip]="'De 0 à ' + lineRal(l)">
                          } @else { — }
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="lines-acts">
                  @if (dt.cancelling) {
                    <button mat-flat-button class="btn-act btn-cancel-ral" [disabled]="saving" (click)="confirmCancel()">
                      <mat-icon>block</mat-icon>Générer le bon d'annulation
                    </button>
                    <button mat-stroked-button class="btn-act btn-ghost" (click)="abortCancel()">Retour</button>
                  } @else {
                    @if (canEditLines) {
                      <button mat-flat-button class="btn-act btn-save" [disabled]="!isDirty || hasBadQty || saving" (click)="saveLines()"
                        matTooltip="Enregistrer les quantités de ce BL (avant de le passer à livré)">
                        <mat-icon>save</mat-icon>Enregistrer le BL
                      </button>
                      <button mat-stroked-button class="btn-act btn-ghost" [disabled]="!isDirty" (click)="resetLines()">Rétablir</button>
                    }
                    <span class="grow"></span>
                    <span [matTooltip]="cancelTooltip">
                      <button mat-stroked-button class="btn-act btn-cancel-open" [disabled]="!canCancelRemaining" (click)="startCancel()">
                        <mat-icon>remove_shopping_cart</mat-icon>Annuler le reste à livrer…
                      </button>
                    </span>
                  }
                </div>
              }
            </div>
          }

          <div class="thumbs">
            @for (a of f.docs; track a.id) {
              <div class="thumb" [class.scan]="isScan(a)">
                <button type="button" class="thumb-img" (click)="openDoc(a)" [matTooltip]="a.name ?? ''">
                  @if (thumbs.get(a.id!)) {
                    <img [src]="thumbs.get(a.id!)" [alt]="a.name">
                  } @else {
                    <mat-icon>{{ a.contenttype === 'application/pdf' ? 'picture_as_pdf' : 'image' }}</mat-icon>
                  }
                </button>
                <div class="thumb-name">{{ a.name }}</div>
                @if (canDelete(a)) {
                  <button type="button" class="thumb-del" (click)="deleteDoc(f, a)" matTooltip="Retirer ce scan"><mat-icon>close</mat-icon></button>
                }
              </div>
            }
          </div>

          <div class="dropzone" [class.drag-over]="dragOverId === f.d.id" tabindex="0" role="button"
            (click)="previewPicker.click()" (keydown.enter)="previewPicker.click()" (keydown.space)="$event.preventDefault(); previewPicker.click()"
            (dragover)="onDragOver(f, $event)" (dragleave)="onDragLeave(f)" (drop)="onDrop(f, $event)">
            @if (f.uploading) {
              <mat-progress-spinner mode="indeterminate" diameter="22" strokeWidth="3"></mat-progress-spinner>
            } @else {
              <mat-icon>document_scanner</mat-icon>
            }
            <span>Déposer ici le scan du BL signé<br><small>ou cliquer pour choisir (PDF, JPEG, PNG, WebP, TIFF, HEIC)</small></span>
          </div>
          <input #previewPicker type="file" hidden multiple accept="application/pdf,image/jpeg,image/png,image/webp,image/tiff,image/heic" (change)="onFilesPicked(f, previewPicker)">
        </div>
      } @else {
        <div class="preview-card preview-empty">
          <mat-icon>touch_app</mat-icon>
          <span>Cliquez un BL pour voir ses lignes face à la commande, corriger ses quantités, annuler le reste à livrer et déposer le scan du BL signé.</span>
        </div>
      }
    </div>

  </div>
</div>
